// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"c5858ac3","376":"3e8f0a09","453":"cfd59cba"}[chunkId] + ".chunk.js";
};